import CloseButton from './component.styles'
export default CloseButton
